import ApplicationController from './application_controller';

// Sign-by-link page: the form submits natively (turbo: false) and redirects back
// to the same URL, so the browser restores the prior scroll position. With a long
// list that leaves the success/error flash off-screen. When a flash is present on
// load, jump to the top so the signer sees the confirmation.
export default class extends ApplicationController {
  connect() {
    if (this.element.querySelector('.alert')) {
      // Reuse the app's shared scroll helper (packs/application.js) for consistent
      // behavior; fall back to an instant jump if it isn't loaded.
      requestAnimationFrame(() => (window.scrollToTop ? window.scrollToTop() : window.scrollTo(0, 0)));
    }
  }
}
